export default function audioPlayer() {
  return {
    _id: false,
    type: 'droplet.audioPlayer',
    isShared: false,
    templateRegion: false,
    audioFile: `${process.env.S3_ASSETS_URL}multi-media/sample-audio.mp3`,
    title: 'Your Title Here',
    mediaQueries: [
      {
        global: true,
        selector: '.drzAudio',
        properties: [
          {
            property: 'transform',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: ', .drzAudio',
        properties: [
          {
            property: 'display',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-controls',
        properties: [
          {
            property: 'color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-volSlider::-webkit-slider-thumb',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-volSlider::-moz-range-thumb',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-volSlider::-ms-thumb',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAudio-progress',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/audio-player/droplet.schema.js